import { extend, ResponseError } from 'umi-request';

const { REACT_APP_BACKEND } = process.env;

let isRefreshing = false;
let refreshQueue: (() => void)[] = [];

const processQueue = () => {
    refreshQueue.forEach(cb => cb());
    refreshQueue = [];
};

const errorHandler = (error: ResponseError) => {
  if (error.response) {
    console.error(`API Error: ${error.response.status}`, error.data);
  } else {
    console.error('Network error:', error.message);
  }
  throw error;
};

const request = extend({
  prefix: REACT_APP_BACKEND || '/api/v1',
  timeout: 300000,
  errorHandler,
  credentials: 'include',
});

export { request };

export const requestWithRefresh = async <T = any>(url: string, options: any = {}): Promise<T> => {
    try {
        return await request(url, options) as T;
    } catch (error: any) {
        if (error?.response?.status === 401 && !options._retry) {
            if (!isRefreshing) {
                isRefreshing = true;
                try {
                    await request('/auth/refresh', {
                        method: 'POST',
                        credentials: 'include',
                    });
                    processQueue();
                } catch (refreshErr) {
                    refreshQueue = [];
                    throw refreshErr;
                } finally {
                    isRefreshing = false;
                }
            }

            return new Promise<T>((resolve, reject) => {
                refreshQueue.push(async () => {
                try {
                    const retryResponse = await request(url, {
                        ...options,
                        _retry: true,
                    }) as T;
                    resolve(retryResponse);                  
                } catch (retryErr) {
                    reject(retryErr);
                }
                });
            });
        }

        throw error;
    }
};